import React from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchItemList,
  DemoWorkbenchPill,
} from "@csk/demo-ui";

export function ClaimsPanel(): React.JSX.Element {
  return (
    <DemoWorkbenchCard title="Threat model & claims">
      <div className="text-sm text-slate-300 space-y-3">
        <div>
          <DemoWorkbenchCopy tone="bright" className="font-semibold">
            Core forbidden shape
          </DemoWorkbenchCopy>
          <div className="mt-1 flex flex-wrap gap-2">
            <DemoWorkbenchPill>
              SEPARATE.MIXED_SQUARE.EPISTEMIC_TO_EXEC
            </DemoWorkbenchPill>
            <DemoWorkbenchPill>
              missing bridge: G1.EPISTEMIC_TO_EXEC_TEXT2HTTP
            </DemoWorkbenchPill>
          </div>
        </div>
        <div>
          <DemoWorkbenchCopy tone="bright" className="font-semibold">
            What the demo proves
          </DemoWorkbenchCopy>
          <DemoWorkbenchItemList
            className="mt-1"
            items={[
              {
                id: "baseline",
                label:
                  "Baseline: untrusted prompt injection triggers HTTP exfiltration (simulated).",
              },
              {
                id: "governed",
                label:
                  "CSK: malicious path is refused; receipts cite missing bridge and forbidden shape.",
              },
              {
                id: "safe",
                label:
                  "Safe allowlisted path still executes under Regime 2/3 constraints (approval/budget).",
              },
            ]}
          />
        </div>
        <DemoWorkbenchCopy size="xs" tone="muted">
          See docs/THREAT_MODEL_AND_CLAIMS.md for full matrix and scope
          boundaries.
        </DemoWorkbenchCopy>
      </div>
    </DemoWorkbenchCard>
  );
}
